<template>
    <div id="BinMovement" class="row">
        <TabNav :tabs="['Single Item', 'Multiple Items']" :selected="selected" @selected="setSelected" >
            <Tab :isSelected="selected === 'Single Item'">
                <Single />

            </Tab>
            <Tab :isSelected="selected === 'Multiple Items'">
                <Multiple />
            </Tab>
        </TabNav>
    </div>
</template>

<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'
  import Single from './Xfer/Single'
  import Multiple from './Xfer/Multiple'
  export default {
    name: 'BinMovement',
    components: {
      TabNav,
      Tab,
      Single,
      Multiple
    },
    mounted() {
      this.isPowerScan = true;
    },
    data() {
      return {
        selected: 'Single Item',
        isPowerScan: this.$store.getters['Navigation/isPowerScan'],
      }
    },
    methods: {
      setSelected(tab) {
        this.selected = tab
      }
    }
  }
</script>
